import {
    NavLink
  } from "react-router-dom";

import {ReactComponent as Logo } from '../img/logo.svg';

// si hay error de autentificación
import { NewPass } from "../components/NewPass";

import Navigation from '../components/Navigation';

// export async function loader() {
//   const pacientes = await API.getAllPacientes();
//   return { pacientes };
// }

export function NewPassPage() {
  const isAuthenticated = !!sessionStorage.getItem("token");
  return (
    <>
      
      <div id="sidebar">
      {/* <NewPass /> */}
        <div className="logo"><Logo /></div>
        
        {/* other code */}


        {/* other code */}
      </div>
      { isAuthenticated ? (
      <main id="main">
        <Navigation />
        <div id="detail">
          <NewPass />
        </div>
      </main>
      ) : (
      <main id="main">
        <div id="detail">
          <NewPass />
        </div>
      </main>
      ) }
    </>
  );
}